import { render, staticRenderFns } from "./PartnershipMobileCards.vue?vue&type=template&id=12f1d062&"
import script from "./PartnershipMobileCards.vue?vue&type=script&lang=js&"
export * from "./PartnershipMobileCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports